import { Component, Injector, Input, OnInit } from '@angular/core';

import { MessageService } from 'primeng/api';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { HubspotFormService } from '@Common/Misc/services/hubspot-form.service';
import { HubspotFormTypeEnum } from '@Common/Misc/enums/hubspot-form-type.enum';
import { ConfirmDialogComponent } from '@Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';

@Component({
    selector: 'agpr-analysis-upsell-popup',
    templateUrl: './analysis-upsell-popup.component.html',
    styleUrls: ['./analysis-upsell-popup.component.scss'],
    standalone: false
})
export class AnalysisUpsellPopupComponent extends AbstractDialogComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() positionY: number = 0;
    @Input() positionX: number = 0;
    @Input() icon: string = 'fa-kit-duotone fa-agpr-insights';
    @Input() heading: string = 'Mention.coverage.insights.upsell.heading';
    @Input() message: string = 'Mention.insights.upsell.message';
    @Input() bullets: string[] = [
        'Mention.insights.upsell.message.bullet1',
        'Mention.insights.upsell.message.bullet4',
        'Mention.insights.upsell.message.bullet5'
    ];
    @Input() endMessage: string = 'Mention.coverage.insights.upsell.message.wantToAccess';

    // Which feature the "unlock" request is for: the hubspot form value, the plain feature name used in the
    // white label mailto templates, and the confirmation shown once the request goes through
    @Input() hubspotFormType: HubspotFormTypeEnum = HubspotFormTypeEnum.INTELLIGENT_INSIGHTS;
    @Input() featureName: string = 'Coverage Insights';
    @Input() confirmationHeading: string = 'Mention.insights.upsell.unlock.confirmation.header';
    @Input() confirmationMessage: string = 'Mention.coverage.insights.upsell.unlock.confirmation.message';

    selfClick: boolean = false;
    loading: boolean = false;
    isWhiteLabeledBrand: boolean = false;



    constructor(
        public coreDialogService: CoreDialogService,
        public configService: ConfigService,
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public injector: Injector,
        protected hubspotFormService: HubspotFormService,
    ) {
        super(coreDialogService, 'AnalysisUpsellPopup');
    }

    ngOnInit() {
        this.isWhiteLabeledBrand = this.configService.isWhiteLabelBrand();
    }

    unlock(): void {
        this.loading = true;
        this.hubspotFormService.requestUnlock(this.hubspotFormType, this.featureName).then(submitted => {
            this.loading = false;
            if (submitted) {
                this.closeDialog();
                this.coreDialogService.open(
                    ConfirmDialogComponent,
                    {
                        inputs: {
                            heading: this.confirmationHeading,
                            messageHtml: this.confirmationMessage,
                            cancelLabel: 'cancel',
                            width: 600
                        }
                    }
                );
            }
        }).catch(err => {
            window.open('https://www.agilitypr.com/contact/');
            this.loading = false;
        });
    }

    cancel(): void {
        this.closeDialog();
    }

    setSelf(event) {
        if (event?.stopPropagation) {
            event.stopPropagation();
        }
        this.selfClick = true;
    }
}
